import type {WidgetFragment as Widget} from 'nutshell-graphql-types';

import {CustomFieldsWidgetShell} from '../../../../core-entity/widgets/custom-fields-widget/components/custom-fields-widget-shell';
import {useGetWidgetCustomFields} from '../../../../core-entity/widgets/custom-fields-widget/graphql/hooks/use-get-widget-custom-fields';

import {useAccountCustomFieldHandlers} from '../../hooks/use-account-custom-field-handlers';

interface Props {
    accountId: string;
    widget: Widget;
}

export function AccountCustomFieldsWidget(props: Props) {
    const handlers = useAccountCustomFieldHandlers(props.accountId);
    const {customFields, isFirstLoad} = useGetWidgetCustomFields(props.accountId, props.widget.id);

    return (
        <CustomFieldsWidgetShell
            entityId={props.accountId}
            widget={props.widget}
            handlers={handlers}
            emptyStateKey='leadCustomFields'
            customFields={customFields}
            isFirstLoad={isFirstLoad}
        />
    );
}
